import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';

interface Item {
  image: string | undefined;
  name: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AvatarCard',
  props: {
  item: {
    type: Object as PropType<Item>,
  },
  canEdit: {
    type: Boolean,
    default: false,
    required: false
  },
  size: {
    type: String as PropType<'small' | 'large'>,
    default: "small",
    required: false
  }},
  emits: ['on-edit'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;

function getInitials(name: string): string {
  if (!name) return '';
  const words = name.trim().split(/\s+/);
  if (words.length === 1) return name[0].toUpperCase();
  return (name[0] + words[1][0]).toUpperCase();
}


const __returned__ = { emit, getInitials }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})